import { CONFIG } from "../config/app-config";
import { APIS, getApi, postApi, putApi } from "../utils/api-utils";

export const getInceptionCompanies = async () => {
    if (!CONFIG.mobileApiKey) {
        throw new Error("Missing REACT_APP_MOBILE_API_KEY");
    }

    const response = await fetch(`${CONFIG.baseApiUrl}/${CONFIG.stage}-mobile-api/mobile/tenant/names`, {
        headers: {
            "X-API-Key": CONFIG.mobileApiKey
        }
    });

    if (!response.ok) {
        throw new Error("Failed to fetch companies");
    }

    const tenants = await response.json();
    return (Array.isArray(tenants) ? tenants : [])
        .filter((tenant: any) => !!tenant?.tenantId && !!tenant?.buildingId && !!tenant?.name)
        .sort((a: any, b: any) =>
            String(a.name).localeCompare(String(b.name), undefined, { sensitivity: "base", numeric: true })
        );
};

export const getInceptionSettings = async (buildingId: string, tenantId: string) => {
    return await getApi(APIS.INTEGRATION_API, `/inception/settings/${buildingId}/${tenantId}`);
};

export const getInceptionCredentialTemplates = async (buildingId: string, tenantId: string) => {
    return await getApi(APIS.INTEGRATION_API, `/inception/credential-templates/${buildingId}/${tenantId}`);
};

export const updateInceptionSettings = async (buildingId: string, tenantId: string, payload: any) => {
    return await putApi(APIS.INTEGRATION_API, `/inception/settings/${buildingId}/${tenantId}`, payload);
};

export const testInceptionConnection = async (payload: any) => {
    return await postApi(APIS.INTEGRATION_API, "/inception/test-connection", payload);
};
